import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEvents} from "../../shared/dto/aps.events";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommon} from "../../shared/dto/aps.common";
import * as angular from "angular";
import * as _ from "lodash";
import * as moment from 'moment';
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import {States} from "../../shared/config/constant.module";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {NotificationService} from "../../services/notifications/notification.service";
import SectionChangeServiceName, {SectionChangeService} from "../../services/toolChange/sectionChange.service";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";
import CheckListInstancesServiceName, {CheckListInstancesService} from "../../services/checkLists/checkListInstances.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import CheckListReportDetailsName, {openCheckListReportDetails} from "../../controllers/checkLists/checkListReportDetails.controller";
import FillOutCheckListName, {openFillOutCheckList} from "../../controllers/checks/fillOutCheckList.controller";
import ViewDefectName, {openViewDefect} from "../../controllers/defects/viewDefect.controller";
import NotificationCommentName, {openNotificationComment} from "../../controllers/notifications/notificationComment.controller";
import { CronJob, job } from "cron";
import JobRunServiceName, {JobRunService} from "../../services/jobs/jobRun.service";
import { apsCommands } from "../../shared/dto/aps.commands";

let requires = [AuthDataServiceName, NotifyServiceName, NavigationServiceName, LoaderServiceName,
  SectionChangeServiceName, CheckListsServiceName, CheckListInstancesServiceName, CheckListReportDetailsName,
  FillOutCheckListName, ViewDefectName, NotificationCommentName, JobRunServiceName, NewGuidServiceName];

export interface Notification extends apsViewModels.NotificationItem {
  isReadAvailable(): boolean;
  isDoneAvailable(): boolean;
  isFillOutAvailable(): boolean;
  isSignOffAvailable(): boolean;
  isViewCheckListDetailsAvailable(): boolean;
  read(): void;
  done(): void;
  fillOut(): void;
  viewCheckListDetails(): void;
  doneLabel: string;
  isSectionChangeAvailable(): boolean;
  sectionChange(): void;
}

export interface NotificationConstructable {
  new(data: apsViewModels.NotificationItem,
      parent: Notifications,
      notificationService: NotificationService): Notification;
}

export interface Notifications {
  notifications: Notification[];
  showNotifications(): boolean;
  toggleShowNotifications(event: MouseEvent): void;
  unreadNotifications(): number;
  showUnread(): boolean;
  addNotification(notification: apsViewModels.NotificationItem): void;
  markRead(notification: apsEvents.NotificationRead): void;
  remove(notification: {id: string}): void;
}

export interface NotificationsConstructable {
  new(data: apsViewModels.NotificationItem[],
      notificationService: NotificationService,
      $window: angular.IWindowService,
      $scope: angular.IScope): Notifications;
}
class NotificationImpl implements Notification {
  static loaderService: LoaderService;
  static notifyService: NotifyService;
  static $state: angular.ui.IStateService;
  static $modal: mm.foundation.modal;
  static $window: angular.IWindowService;
  static sectionChangeService: SectionChangeService;
  static checkListsService: CheckListsService;
  static checkListInstancesService: CheckListInstancesService;
  static navigationService: NavigationService;
  static jobRunService: JobRunService;
  static authDataService: AuthDataService;
  static newGuidService: NewGuidService;
  private notificationService: NotificationService;
  id: string;
  title: string;
  description: string;
  detail: string;
  url: string;
  status: apsEnums.NotificationStatus;
  sendOn: Date;
  sentOn: Date;
  type: apsEnums.NotificationType;
  location: apsEnums.Location;
  plantId: string;
  tankId: string;
  shopId: string;
  roleId: string;
  shifts: apsEnums.Shift;
  isMachineId: string;
  section: number;
  gob: number;
  sendToUserId: string;
  createdById: string;
  doneLabel: string;
  doneRequiresComment: boolean;
  doneCommentTitle: string;
  private parent: Notifications;

  constructor(
    data: apsViewModels.NotificationItem,
    parent: Notifications,
    notificationService: NotificationService,
    authDataService: AuthDataService) {
    _.assign(this, data);
    this.parent = parent;
    this.notificationService = notificationService;
    switch (this.type) {
      case apsEnums.NotificationType.CriticalDefect:
        this.doneLabel = 'View Defect';
        break;
      case apsEnums.NotificationType.CheckList:
        this.doneLabel = 'Not able to complete';
        this.doneCommentTitle = 'Dismiss Check List';
        break;
      default:
        this.doneLabel = 'Done';
    }
  }

  isReadAvailable(): boolean {
    return this.status === apsEnums.NotificationStatus.Sent;
  }

  isDoneAvailable(): boolean {
    return this.status < apsEnums.NotificationStatus.Done
      && this.type !== apsEnums.NotificationType.CheckListSignOff
      && this.type !== apsEnums.NotificationType.SectionChange;
  }

  isFillOutAvailable(): boolean {
    return this.type === apsEnums.NotificationType.CheckList;
  }

  isSignOffAvailable(): boolean {
    return this.type === apsEnums.NotificationType.CheckListSignOff;
  }

  isSectionChangeAvailable(): boolean {
    return this.type === apsEnums.NotificationType.SectionChange;
  }

  isViewCheckListDetailsAvailable(): boolean {
    return this.type === apsEnums.NotificationType.CheckListEdited;
  }

  go(): void {
    this.read();
    NotificationImpl.$window.open(this.url);
  }

  read(): void {
    if (!this.isReadAvailable()) {
      return;
    }

    this.notificationService.readNotification(this.id)
      .then(() => {
        this.status = apsEnums.NotificationStatus.Read;
      }, NotificationImpl.notifyService.handleApiErrors);
  }

  done(): void {
    if (!this.isDoneAvailable()) {
      return;
    }

    var doneComment = null;

    var submitDone = () => {
      var promise = this.notificationService.completeNotification(this.id, doneComment)
        .then(() => {
          this.parent.remove(this);

          if (this.type === apsEnums.NotificationType.CriticalDefect) {
            this.viewDefect();
          }
        }, NotificationImpl.notifyService.handleApiErrors);
      NotificationImpl.loaderService.loadingPromise(promise);
    };

    if (this.doneRequiresComment) {
      let result = openNotificationComment({
        title: this.doneCommentTitle
      }, NotificationImpl.$modal);

      result.then((comment) => {
        doneComment = comment;
        submitDone();
      });
    } else {
      submitDone();
    }
  }

  sectionChange(): void {
    if (!this.isSectionChangeAvailable()) {
      return;
    }

    NotificationImpl.sectionChangeService.openToolChangeForSectionChange({
      sectionChangeId: this.detail,
      sectionChangeSectionId: this.id,
      shopId: this.shopId,
      isMachineId: this.isMachineId,
      section: this.section
    });
  }

  skipSectionChange(): void {
    if (!this.isSectionChangeAvailable()) {
      return;
    }

    NotificationImpl.sectionChangeService.skipSectionChange({
      sectionChangeId: this.detail,
      id: this.id,
      shopId: this.shopId
    }).catch(NotificationImpl.notifyService.handleApiErrors);
  }

  private viewDefect() {
    openViewDefect({
      defectId: this.detail,
      defect: null,
      canComment: null,
      gob: null,
      readOnly: null,
      plantId: null
    }, NotificationImpl.$modal);
  }

  fillOut(): void {
    if (!this.isFillOutAvailable()) {
      return;
    }

    this.read();
    if (this.type === apsEnums.NotificationType.CheckList) {
      NotificationImpl.navigationService.getNavigation().then(nav => {
        var plantLocationId = null;
        var plant = _.find(nav.plants(), {id: this.plantId});
        if (this.tankId) {
          var tank = _.find(plant.tanks, {id: this.tankId});
          if (this.shopId) {
            var shop = _.find(tank.shops, {id: this.shopId});
            plantLocationId = shop.plantLocationId;
          } else {
            plantLocationId = tank.plantLocationId;
          }
        } else {
          plantLocationId = plant.plantLocationId;
        }
        openFillOutCheckList({
          checkListId: this.detail,
          instanceId: this.id,
          shopId: this.shopId,
          plantId: this.plantId,
          tankId: this.tankId,
          readOnly: false,
          plantLocationId: plantLocationId,
          scheduledOn: this.sendOn
        }, NotificationImpl.$modal);
      });
    }
  }

  viewCheckListDetails(): void {
    if (!this.isViewCheckListDetailsAvailable() && !this.isSignOffAvailable()) {
      return;
    }

    this.read();

    var data = <apsCommon.CheckListSignOffNotificationDetail>JSON.parse(this.detail);

    var promise = NotificationImpl.checkListsService
      .getCheckListReportDetail(data.instanceId, data.plantLocationId, data.scheduledOn,
        apsEnums.CheckListReportFilter.AllCheckLists)
      .then((detail: apsViewModels.CheckListInstanceReportDetail) => {
        openCheckListReportDetails({
          checkListInstance: detail.reportItem,
          detail: detail
        }, NotificationImpl.$modal);
      });
    NotificationImpl.loaderService.loadingPromise(promise);
  }
}

class NotificationsImpl implements Notifications {
  notifications: Notification[];
  /* tslint:disable:variable-name */
  static Notification: NotificationConstructable;
  /* tslint:enable:variable-name */
  private showNotification: boolean;
  private notificationService: NotificationService;
   static authDataService: AuthDataService;
  static $timeout: angular.ITimeoutService;
  static $: angular.IAugmentedJQuery;
  shopId: string;
  swabTime: number;
  weightTime: number;
  blankTime: number;
  constructor(data: apsViewModels.NotificationItem[],
              notificationService: NotificationService,
              $window: angular.IWindowService,
              $scope: angular.IScope) {
    this.notifications = [];
    this.showNotification = false;
    this.notificationService = notificationService;
    if (NotificationImpl.authDataService.isHEMachineOperator() || NotificationImpl.authDataService.isHEUpkeep()){
      NotificationImpl.navigationService.getNavigation().then(nav => {
        this.shopId = nav.selectedShop.id;
        NotificationImpl.jobRunService.getJobRuns(this.shopId)
        .then((jobRuns) => {
          _.forEach(jobRuns, (jobRun: any) => {
            if (jobRun.endDate == null) {
              if (jobRun.alertTimeWeighBottle != null && jobRun.alertTimeWeighBottle !== 0){
                let cron1 = new CronJob('1 */' + jobRun.alertTimeWeighBottle + ' * * * *', function() { 
                  let command: apsCommands.WellKnownCheckListCreate = {
                    Id:  null,
                    WellknownCheckId:9,
                    PlantId: nav.selectedPlant.id,
                    ShopId: nav.selectedShop.id,
                    WellKnownCheckListResult: 0,
                    dateTimeString: moment(new Date()).format('MM/DD/YYYY hh:mm A') 
                  };
                  NotificationImpl.newGuidService.getNewGuid('checkListInstance').then(id => command.Id = id); 
                  NotificationImpl.notifyService.alertWeigh(NotificationImpl.checkListInstancesService, command, moment(new Date()).format('MM/DD/YYYY hh:mm A') 
                  + " : \n\r Please Record Bottle Weights");
                }, null, true, 'America/Los_Angeles');
                this.notificationService.setCronJob1(cron1);
                }else{
                  this.notificationService.stopCronJob1();
                }
              if (jobRun.alertTimeSwabMold != null && jobRun.alertTimeSwabMold !== 0){
                  let cron2 = new CronJob('2 */' + jobRun.alertTimeSwabMold + ' * * * *', function() {
                    let command: apsCommands.WellKnownCheckListCreate = {
                      Id:  null,
                      WellknownCheckId:11,
                      PlantId: nav.selectedPlant.id,
                      ShopId: nav.selectedShop.id,
                      WellKnownCheckListResult: 0,
                      dateTimeString: moment(new Date()).format('MM/DD/YYYY hh:mm A') 
                    };
                    NotificationImpl.newGuidService.getNewGuid('checkListInstance').then(id => command.Id = id);
                    NotificationImpl.notifyService.alertMold(NotificationImpl.checkListInstancesService, command, moment(new Date()).format('MM/DD/YYYY hh:mm A') 
                    + " : \n\r Time To Swab The Mold Side");
                  }, null, true, 'America/Los_Angeles');
                  this.notificationService.setCronJob2(cron2);
                }else{
                  this.notificationService.stopCronJob2();
                }
              if (jobRun.alertTimeSwabBlank != null && jobRun.alertTimeSwabBlank !== 0){
                let cron3 = new CronJob('3 */' + jobRun.alertTimeSwabBlank + ' * * * *', function() {
                  let command: apsCommands.WellKnownCheckListCreate = {
                    Id:  null,
                    WellknownCheckId:10,
                    PlantId: nav.selectedPlant.id,
                    ShopId: nav.selectedShop.id,
                    WellKnownCheckListResult: 0,
                    dateTimeString: moment(new Date()).format('MM/DD/YYYY hh:mm A') 
                  };
                  NotificationImpl.newGuidService.getNewGuid('checkListInstance').then(id => command.Id = id);
                  NotificationImpl.notifyService.alertBlank(NotificationImpl.checkListInstancesService, command, moment(new Date()).format('MM/DD/YYYY hh:mm A') 
                  + " : \n\r Time To Swab The Blank Side");
                }, null, true, 'America/Los_Angeles');
                this.notificationService.setCronJob3(cron3);
              }else{
                this.notificationService.stopCronJob3();
              }
            }
          });
        });
      });
    }

    /*hardcode alert*/    
    _.forEach(data, (notification) => {
      if (!this.checkPlant(notification)) {
        return;
      }
      this.notifications.push(new NotificationsImpl.Notification(notification, this, this.notificationService));
      if(notification.type === apsEnums.NotificationType.CriticalDefect)
      {
        if(notification.status !== apsEnums.NotificationStatus.Read)
        {
          NotificationImpl.notifyService.alertCritical(this.notificationService, notification.id, notification.description, notification.title + " - " + notification.sentOn.toLocaleDateString() + " " + notification.sentOn.toLocaleTimeString());
        }
      }
    });

    $($window).click(() => {
      if (this.showNotification) {
        NotificationsImpl.$timeout(() => {
          this.showNotification = false;
        });
      }
    });
  }

  private checkPlant(notification: {plantId: string}): boolean {
    if (!notification.plantId) {
      return true;
    }
    var role = NotificationsImpl.authDataService.getSelectedRoleLocation().role;
    return !role.roleRequiresPlants || _.some(role.plants, (p: apsCommon.IdAndName) => p.id === notification.plantId);
  }

  showNotifications(): boolean {
    return this.showNotification;
  }

  toggleShowNotifications(event: MouseEvent): void {
    this.showNotification = !this.showNotification;
    event.stopPropagation();
  }

  unreadNotifications(): number {
    return _.filter(this.notifications, {status: apsEnums.NotificationStatus.Sent}).length;
  }

  showUnread(): boolean {
     return this.unreadNotifications() > 0;
  }

  addNotification(notification: apsViewModels.NotificationItem): void {
    if (!this.checkPlant(notification)) {
      return;
    }
    this.notifications.unshift(new NotificationsImpl.Notification(notification, this, this.notificationService));
    if(notification.type === apsEnums.NotificationType.CriticalDefect)
    {
      NotificationImpl.notifyService.alertCritical(this.notificationService, notification.id, notification.description, notification.title + " - " + notification.sentOn.toLocaleDateString() + " " + notification.sentOn.toLocaleTimeString());
    }
    this.showNotification = true;
  }

  private getNotification(notification: apsEvents.NotificationSentBase): Notification {
    return _.find(this.notifications, {id: notification.id});
  }

  private setStatus(notification: apsEvents.NotificationSentBase,
                    status: apsEnums.NotificationStatus) {
    var existing = this.getNotification(notification);
    if (existing) {
      existing.status = status;
    }
  }

  markRead(notification: apsEvents.NotificationRead) {
    this.setStatus(notification, apsEnums.NotificationStatus.Read);
  }

  remove(notification: {id: string}) {
    _.remove(this.notifications, {id: notification.id});
  }
}

export default angular.module('aps.models.notifications', requires)
  .factory('Notification', (
    loaderService: LoaderService,
    notifyService: NotifyService,
    newGuidService: NewGuidService,
    $state: angular.ui.IStateService,
    $window: angular.IWindowService,
    $modal: mm.foundation.modal,
    sectionChangeService: SectionChangeService,
    jobRunService: JobRunService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    checkListsService: CheckListsService,
    checkListInstancesService: CheckListInstancesService) => {
    NotificationImpl.loaderService = loaderService;
    NotificationImpl.notifyService = notifyService;
    NotificationImpl.newGuidService = newGuidService;
    NotificationImpl.checkListInstancesService = checkListInstancesService;
    NotificationImpl.$state = $state;
    NotificationImpl.$window = $window;
    NotificationImpl.$modal = $modal;
    NotificationImpl.sectionChangeService = sectionChangeService;
    NotificationImpl.checkListsService = checkListsService;
    NotificationImpl.navigationService = navigationService;
    NotificationImpl.jobRunService = jobRunService;
    NotificationImpl.authDataService = authDataService;
    return NotificationImpl;
  })
  /* tslint:disable:variable-name */
  .factory('Notifications', (Notification: NotificationConstructable,
  /* tslint:enable:variable-name */
                             $timeout: angular.ITimeoutService,
                             $: angular.IAugmentedJQuery,
                             authDataService: AuthDataService) => {
    NotificationsImpl.Notification = Notification;
    NotificationsImpl.authDataService = authDataService;
    NotificationsImpl.$timeout = $timeout;
    NotificationsImpl.$ = $;
    return NotificationsImpl;
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/models/notifications/notifications.ts